export const environment = {
  production: false,
  apiBaseUrl: 'https://api.app.dev.cescog.com/api/v1',
  apiAuthBaseUrl: 'https://api.app.dev.cescog.com/auth',
  apiOtpBaseUrl: 'https://api.app.dev.cescog.com/auth/v2',
  privateUrl: 'https://app.dev.cescog.com',
};
